import React, { useEffect, useState } from "react"

function Reminder({
 reminder, index, setReminderList
}) {
  const [currentReminder, setCurrentReminder] = useState(reminder)

  const onChange = e => {
    e.preventDefault()
    setCurrentReminder({ ...currentReminder, [e.target.name]: e.target.value })
  }

  const onRemove = () => {
    setReminderList(prevList => {
      const clonedList = [...prevList]
      clonedList.splice(index, 1)
      return clonedList
    })
  }

  useEffect(() => {
    setReminderList(prevList => {
      const clonedList = [...prevList]
      clonedList[index] = { ...currentReminder }
      return clonedList
    })
  }, [currentReminder, index, setReminderList])

  return (
    <div className="pb-5">
      <div className="form-group mb-2">
        <label>Reminder Title</label>
        <input
          className="form-control"
          name="title" // behaving strange
          onChange={onChange}
          placeholder="You have a reminder..."
          value={currentReminder.title}
          type="text" />
      </div>
      <div className="form-group mb-2">
        <label>Reminder Body</label>
        <input
          className="form-control"
          name="body"
          onChange={onChange}
          placeholder="You have a reminder..."
          value={currentReminder.body}
          type="text" />
      </div>
      <div className="form-group mb-2">
        <label>Reminder Date</label>
        <input
          className="form-control"
          onChange={onChange}
          name="trigger_date"
          type="date" />
      </div>
      <div className="btn-container">
        <button type="button" className="btn btn-main btn-xs mr-3" onClick={onRemove}>
          Remove reminder
        </button>
      </div>
    </div>
  )
}

export default Reminder